import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { motion, AnimatePresence } from "framer-motion";

const ContactSection = () => {
  const form = useRef();
  const [toast, setToast] = useState({ show: false, message: "", type: "" });

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_57y99oi", // 🔹 Your EmailJS service ID
        "template_flubojh", // 🔹 Your template ID
        form.current,
        "VJaC_Js1QJiZC0W9A" // 🔹 Your public key
      )
      .then(
        () => {
          setToast({
            show: true,
            message: "Message sent successfully ✅",
            type: "success",
          });
          form.current.reset();
        },
        (error) => {
          console.error("Error:", error.text);
          setToast({
            show: true,
            message: "Something went wrong ❌ Please try again.",
            type: "error",
          });
        }
      );

    setTimeout(() => setToast({ show: false, message: "", type: "" }), 4000);
  };

  return (
    <section className="contact-one">
      <div
        className="contact-one__bg"
        style={{
          backgroundImage: "url(assets/images/backgrounds/contactbanner.png)",
        }}
      ></div>
      <div className="shape1">
        <img src="assets/images/shapes/contact-v1-shape1.png" alt="" />
      </div>
      <div className="container">
        <div className="contact-one__inner clearfix">
          {/*Start Contact One Form*/}
          <div
            className="contact-one__form wow fadeInRight"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div className="sec-title sec-title-animation animation-style2">
              <div className="sec-title__tagline">
                <div className="left-line" />
                <div className="text">
                  <h4>Get In Touch</h4>
                </div>
              </div>
              <h2 className="sec-title__title title-animation">
                We’d Love to Hear From You
              </h2>
            </div>

            <form
              ref={form}
              onSubmit={sendEmail}
              className="contact-form-validated contact-one__form-box"
            >
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="input-box">
                    <input
                      type="text"
                      name="from_name"
                      placeholder="Full Name*"
                      required
                    />
                  </div>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-6">
                  <div className="input-box">
                    <input
                      type="email"
                      name="from_email"
                      placeholder="Email Address*"
                      required
                    />
                  </div>
                </div>

                <div className="col-xl-12">
                  <div className="input-box">
                    <textarea
                      name="message"
                      placeholder="Your Message"
                      defaultValue=""
                      required
                    />
                  </div>
                </div>

                <div className="col-xl-12">
                  <div className="contact-page__form-btn">
                    <button type="submit" className="thm-btn">
                      Contact Us <span className="icon-diagonal-arrow1" />
                    </button>
                  </div>
                </div>
              </div>
            </form>

            {/* 🔹 Toast Notification */}
            <AnimatePresence>
              {toast.show && (
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 50 }}
                  transition={{ duration: 0.4 }}
                  className={`fixed bottom-6 right-6 px-5 py-3 rounded-xl shadow-lg text-white ${
                    toast.type === "success" ? "bg-green-600" : "bg-red-600"
                  }`}
                >
                  {toast.message}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          {/*End Contact One Form*/}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
